module.exports = {
  path: 'add',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/RolloutAdd'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/rollouts/routes/add/index.js